import { FC, useState, useEffect } from 'react';
import useSingleTTNews from '../CustomHooks/useSingleTTNews';
import moment from 'moment';
import 'moment/locale/sv';

import Loader from '../GeneralComponents/Loader';
import { AssetService, Fit } from '~js/React/services/generatedApi';
import useMediaQuery from '../CustomHooks/useMediaQuery';

type Props = {
  singleNewsId: string;
  backLink: string;
  backText: string;
};

const SingleTTNewsPage: FC<Props> = ({ singleNewsId, backLink, backText }) => {
  const { data: newsItem, isLoading } = useSingleTTNews(singleNewsId);
  const [cropImg, setCropImg] = useState<string>('');
  const [cropImgMobile, setCropImgMobile] = useState<string>('');
  const [bgBlurImg, setbgBlurImg] = useState<string>('');
  const isBigScreen = useMediaQuery('(min-width: 560px)');
  const [isLoadingImg, setIsLoadingImg] = useState<boolean>(true);

  useEffect(() => {
    async function cropImage() {
      if (newsItem?.mainImage?.url) {
        setCropImg(
          await AssetService.assetGetResizedImage(
            newsItem?.mainImage?.url,
            780,
            540,
            Fit.INSIDE,
            80
          )
        );
        setCropImgMobile(
          await AssetService.assetGetResizedImage(
            newsItem?.mainImage?.url,
            680,
            480,
            Fit.INSIDE,
            80
          )
        );
        setbgBlurImg(
          await AssetService.assetGetResizedImage(
            newsItem?.mainImage?.url,
            100,
            100,
            Fit.INSIDE,
            60
          )
        );
        setIsLoadingImg(false);
      }
    }
    cropImage();
  }, [newsItem?.mainImage?.url]);

  moment.locale('sv');

  return (
    <>
      {!isLoading && !isLoadingImg && (
        <>
          {cropImg && (
            <section className="relative mx-auto mdplus:mt-6 max-w-2xl overflow-hidden hero-section">
              <picture>
                {isBigScreen === false && (
                  <img
                    src={cropImgMobile}
                    alt={
                      newsItem?.mainImage?.caption
                        ? newsItem?.mainImage?.caption
                        : newsItem?.mainImage?.title
                    }
                    className="block w-full max-h-sm object-contain"
                  />
                )}
                {isBigScreen && (
                  <img
                    src={cropImg}
                    alt={
                      newsItem?.mainImage?.caption
                        ? newsItem?.mainImage?.caption
                        : newsItem?.mainImage?.title
                    }
                    className="block mx-auto min-h-68 max-h-md object-contain"
                  />
                )}
              </picture>
              <div
                className="-z-10 absolute inset-0 bg-blue1100 bg-contain bg-no-repeat bg-center blur-[15px] scale-[2.5]"
                style={{ backgroundImage: `url(${bgBlurImg}` }}
              ></div>
            </section>
          )}
          <div className="mx-auto px-3 xl:px-0 pt-4 lg:pt-6 pb-2 lg:pb-0 max-w-2xl">
            <a
              href={backLink}
              className="inline-flex items-center mb-2 hover:underline"
            >
              <img
                width={20}
                height={10}
                className="mr-3 w-5 rotate-180 transform"
                src="/Images/Icons/Arrows/arrow-right-black500.svg"
                alt="Ikon pil tillbaka"
              />
              {backText}
            </a>
          </div>
          <section className="lg:my-4 contentSection umbraco-section pressSection pressSingleSection">
            <div className="mx-auto px-3 xl:px-0 max-w-2xl pressContainer">
              {newsItem?.title && (
                <h1 className="text-blue500 lg:text-4xl">{newsItem?.title}</h1>
              )}
              {newsItem?.published && (
                <p className="mb-1 text-grey300 date">
                  {moment(newsItem?.published).format('YYYY-MM-DD')}
                </p>
              )}
              {newsItem?.leadTextOrBodyStrip && (
                <p className="my-3 md:my-5 leading-6 preamble">
                  {newsItem?.leadTextOrBodyStrip}
                </p>
              )}
              {newsItem?.body && (
                <div
                  className="font-ic leading-6 press-text"
                  dangerouslySetInnerHTML={{ __html: newsItem?.body }}
                ></div>
              )}
              {newsItem?.documents && newsItem?.documents.length > 0 && (
                <>
                  <h4 className="font-icb">Dokument</h4>
                  <p className="text">
                    {newsItem?.documents?.map((document) => {
                      return <a href={document?.url}>{document?.caption}</a>;
                    })}
                  </p>
                </>
              )}
            </div>
          </section>
        </>
      )}
      {(isLoading || isLoadingImg) && (
        <div className="flex justify-center items-center py-16">
          <Loader />
        </div>
      )}
    </>
  );
};

export default SingleTTNewsPage;
